<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Historial</li>
</ol>

<h1 class="page-header"><i class="fas fa-clock-rotate-left"></i> Historial<small> Periodos cerrados de {{module?.name || 'evaluación'}}</small></h1>

<div class="scrollable">
  @if(!module) {
  <div class="alert alert-warning">
    <i class="fas fa-triangle-exclamation"></i>
    No se encontró un módulo activo para la ruta <b>"{{routeSegment}}"</b>.
    @if(availableRoutes.length > 0) {
    Rutas disponibles: <b>{{availableRoutes.join(', ')}}</b>.
    } @else {
    El sistema no devolvió módulos activos.
    }
    Verifica que el ítem de menú tenga asignado el módulo y que la URL sea <b>/:route/historial</b>.
  </div>
  }
  <panel title="Filtros" [noButton]="true">
    @if(module && groups.length === 0) {
    <div class="alert alert-info mb-3">
      <i class="fas fa-circle-info"></i>
      Este módulo no tiene grupos configurados. Asígnelos en <b>Administración → Módulos</b>.
    </div>
    }
    <div class="row">
      <div class="col-md-4">
        Grupo
        <ng-select [items]="groups" bindLabel="name" [(ngModel)]="selectedGroup" [clearable]="false" (ngModelChange)="onFilterChange()"></ng-select>
      </div>
      <div class="col-md-3">
        Año
        <ng-select [items]="years" [(ngModel)]="yearSelected" [clearable]="false" (ngModelChange)="onFilterChange()"></ng-select>
      </div>
    </div>
  </panel>

  <panel title="Periodos cerrados" [noButton]="true">
    <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Periodo</th>
            <th>Entidad</th>
            <th class="text-center">Puntaje</th>
            <th class="text-center">Nivel</th>
            <th class="text-center">Expiración</th>
            <th class="text-center">Realizado por</th>
            <th class="text-center">Firma</th>
            <th class="text-center">Acción</th>
          </tr>
        </thead>
        <tbody>
          @for(p of rows; track p.id) {
          <tr>
            <td class="text-nowrap">{{periodLabel(p)}}</td>
            <td>{{p.entity?.code}} — {{p.entity?.name}}</td>
            <td class="text-center">{{p.score ?? '-'}}</td>
            <td class="text-center">{{p.level || '-'}}</td>
            <td class="text-center">{{p.expiration | date:'dd-MM-yyyy'}}</td>
            <td class="text-center">
              @if(p.realized) {
              {{p.realizedUser?.displayName}}<br /><small>{{p.realized | date:'dd-MM-yyyy'}}</small>
              } @else { - }
            </td>
            <td class="text-center">
              @if(p.signedDate) {
              {{p.signedUser?.displayName}}<br /><small>{{p.signedDate | date:'dd-MM-yyyy'}}</small>
              } @else { Sin firma }
            </td>
            <td class="text-center">
              <button class="btn btn-xs btn-ghost" triggers="hover" ngbTooltip="Visualizar" (click)="viewPeriod(p)">
                <i class="fas fa-eye"></i>
              </button>
            </td>
          </tr>
          }
          @if(rows.length === 0) {
          <tr>
            <td colspan="8" class="text-center text-muted py-4">
              <i class="fas fa-box-archive fa-2x mb-2 d-block"></i>
              No hay periodos cerrados para este año
            </td>
          </tr>
          }
        </tbody>
      </table>
  </panel>
</div>
